import React, { useRef, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { Node } from '@uncinc/react-drupal-core';

import Pager from '../../../components/Pager';
import './style.scss';

const ViewLatestProjects = (props) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const viewIsLoaded = useRef(null);
  const { entities, pager, page, setCurrentPage } = props;
  const totalPages = pager.get('total_pages');

  useEffect(() => {
    if (ref.current) {
      if (viewIsLoaded.current) {
        ref.current.scrollIntoView();
      } else {
        viewIsLoaded.current = true;
      }
    }
  }, [ref, page]);

  const isLoading = useMemo(() => {
    return page !== pager.get('current_page');
  }, [page, pager]);

  const ViewClasses = c('ViewLatestProjects', {
    'ViewLatestProjects--no-pager': totalPages <= 1,
    'ViewLatestProjects--loading': isLoading,
  });

  return (
    entities.size > 0 ? (
      <div className={ViewClasses} ref={ref}>
        <Container>
          <div className="row">
            {entities.map((entity, index) => {
              const id = entity.getIn(['nid', 0, 'value']);
              const uuid = entity.getIn(['uuid', 0, 'value']);
              const large = index === 0;
              return (
                <div key={uuid} className={`col-sm-12 col-md-6 ${large ? 'col-lg-12' : ' col-lg-4'} `}>
                  <Node
                    id={id}
                    entity={entity}
                    viewMode="teaser"
                    large={large}
                    labeled={false}
                    lazyload={index > 3}
                  />
                </div>
              );
            })}
          </div>
          <div className="ViewLatestProjects__pager">
            <Pager currentPage={page} totalPages={totalPages} setCurrentPage={setCurrentPage} />
          </div>
        </Container>
      </div>
    ) : (
      <Container>
        <div className="View__no_results">
          <div className="View__no_results__title">
            {t('filters.no_results') }
          </div>
        </div>
      </Container>
    )
  );
};

export default ViewLatestProjects;
